export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AppLink.vue?vue&type=template&id=6671256c&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/AppLink.vue?vue&type=template&id=6671256c&
// module id = 1754
// module chunks = 0